import type { Resource } from '@openx/types/resources.ts';
import type React from 'react';
import { createContext, useContext, useMemo } from 'react';

import type {
  CommentsFetchProps,
  CommentsFetchResponse,
  HistoryFetchProps,
  HistoryFetchResponse,
} from './CoreContextTypes.tsx';
import { requireDefaults } from './requiredDefaults.tsx';

export interface CoreProviderConfig {
  useCommentsFetch: (props: CommentsFetchProps) => CommentsFetchResponse;
  useHistoryFetch: <R extends Resource>(props: HistoryFetchProps<R>) => HistoryFetchResponse;
}

export interface CoreProviderProps {
  children: React.ReactNode;
  coreConfig: CoreProviderConfig;
}

export type CoreContext = CoreProviderConfig;

const coreContext = createContext<CoreContext>(requireDefaults);

export const useCoreContext = () => useContext(coreContext);

export function CoreProvider({ children, coreConfig }: CoreProviderProps) {
  const value: CoreContext = useMemo(
    () => ({
      ...coreConfig,
    }),
    [coreConfig]
  );

  return <coreContext.Provider value={value}>{children}</coreContext.Provider>;
}
